import { usersPageOpenedEvent } from '../../common/bi-events/users-events/users-page-opened-event';
import { usersOpenPostPageEditorEvent } from './users-open-post-page-editor-event';
import { usersPostPageResizeEvent } from './users-post-page-resize-event';

export const usersEventMap = {
  ...usersPostPageResizeEvent,
  ...usersPageOpenedEvent,
  ...usersOpenPostPageEditorEvent,
};
